import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { orangeCalendarIcon } from 'assets/icons';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getMonth, getYear } from 'date-fns';
import styles from './styles.module.css';
import { Box } from '@mui/material';
import MobileContext from 'context/MobileContext';
import { leftArrowCalendar, rightArrowCalendar } from 'assets/newIcons';
const DateRangePicker = ({
  limit,
  loadHistory,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
}) => {
  const [open, setOpen] = useState(false);
  const [btnDisable, setbtnDisable] = useState(true);
  const isMobile = useContext(MobileContext);
  const onChangeDateRange = dates => {
    // Handle null/undefined case
    if (!dates) {
      setStartDate(null);
      setEndDate(null);
      return;
    }

    // Handle array format (expected behavior)
    if (Array.isArray(dates)) {
      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end);
      return;
    }

    // Handle single Date object format (actual behavior in your localhost)
    if (dates instanceof Date) {
      // If no start date is set, this becomes the start date
      if (!startDate) {
        setStartDate(dates);
        setEndDate(null);
      }
      // If start date exists but no end date, this becomes the end date
      else if (startDate && !endDate) {
        setEndDate(dates);
      }
      // If both dates exist, this starts a new selection
      else {
        setStartDate(dates);
        setEndDate(null);
      }
      return;
    }
  };

  useEffect(() => {
    setbtnDisable(!(startDate && endDate));
  }, [startDate, endDate]);

  const formatDate = date => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const handleSave = () => {
    // Check if both dates are selected
    if (!startDate || !endDate) {
      console.warn('Both start and end dates must be selected');
      return;
    }

    const data = {
      start: formatDate(startDate),
      end: formatDate(endDate),
      limit,
    };
    loadHistory(data);
    setOpen(false);
  };

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  return (
    <div className={styles.container}>
      <div className={styles.input} onClick={() => setOpen(!open)}>
        <div className={styles.dateContainer}>
          <div className={styles.dateSubContainer}>
            <p className={styles.dateHeading}>From:</p>
            <p className={styles.dateContent}>
              {startDate ? moment(startDate).format('MM-DD-YY') : '-'} |
            </p>
          </div>
          <div style={{ marginLeft: '5px' }} className={styles.dateSubContainer}>
            <p className={styles.dateHeading}>To:</p>
            <p className={styles.dateContent}>
              {endDate ? moment(endDate).format('MM-DD-YY') : '-'}
            </p>
          </div>
        </div>
        <img
          style={{ width: isMobile ? 20 : 25, height: isMobile ? 20 : 25 }}
          src={orangeCalendarIcon}
          alt=""
        />
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={styles.modal}
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: 'white',
              borderRadius: '10px',
            }}
          >
            <DatePicker
              renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                <div className={styles.headerAction}>
                  <div className={styles.popupYearHeading}>
                    <p>
                      {months[getMonth(date)]} {getYear(date)}
                    </p>
                  </div>
                  <div className={styles.arrowWrapper}>
                    <img
                      src={leftArrowCalendar}
                      className={styles.leftArrow}
                      alt=""
                      onClick={decreaseMonth}
                    />
                    <img
                      className={styles.rightArrow}
                      src={rightArrowCalendar}
                      alt=""
                      onClick={increaseMonth}
                    />
                  </div>
                </div>
              )}
              selected={startDate}
              maxDate={new Date()}
              onChange={onChangeDateRange}
              startDate={startDate}
              endDate={endDate}
              fixedHeight
              selectsRange={true}
              inline
              shouldCloseOnSelect={false}
              allowSameDay={false}
            />
            <div className={styles.button}>
              <button
                disabled={btnDisable}
                style={{ color: btnDisable ? 'grey' : '#FE5000', cursor: 'pointer' }}
                className={styles.saveButton}
                onClick={handleSave}
              >
                Save
              </button>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};
DateRangePicker.propTypes = {
  limit: PropTypes.number,
  loadHistory: PropTypes.func.isRequired,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  setStartDate: PropTypes.func.isRequired,
  setEndDate: PropTypes.func.isRequired,
};
DateRangePicker.defaultProps = {
  limit: 10,
  startDate: null,
  endDate: null,
};
export default DateRangePicker;
